module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "export",
    attrs: {
      "id": "EXPORT-SWF"
    }
  }, [(_vm.mask_export_1) ? _c('div', {
    staticClass: "mask-export-1"
  }, [_c('div', {
    staticClass: "export-1"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("导出动画")]), _vm._v(" "), _c('div', {
    staticClass: "close"
  }, [_c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        return _vm.handleExportClose()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "export-tabs"
  }, [_c('div', {
    staticClass: "tab",
    class: {
      active: _vm.exportTab === 'video'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('video')
      }
    }
  }, [_vm._v("在线导出")]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.exportTab === 'online'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('online')
      }
    }
  }, [_vm._v("工具导出")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "pic"
  }, [(_vm.anim_thumb) ? _c('img', {
    attrs: {
      "src": _vm.anim_thumb
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.anim_thumb) ? _c('img', {
    attrs: {
      "src": require("./file.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.anim_title))]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("时长:" + _vm._s(_vm.anim_duration))]), _vm._v(" "), _c('el-checkbox-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportTab === 'online'),
      expression: "exportTab==='online'"
    }],
    on: {
      "change": _vm.handleChangeSubtitleAudio
    },
    model: {
      value: (_vm.subtitle_audio_status),
      callback: function($$v) {
        _vm.subtitle_audio_status = $$v
      },
      expression: "subtitle_audio_status"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "带字幕"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "带声音"
    }
  })], 1), _vm._v(" "), _c('el-checkbox-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportTab === 'video'),
      expression: "exportTab==='video'"
    }],
    model: {
      value: (_vm.local_media),
      callback: function($$v) {
        _vm.local_media = $$v
      },
      expression: "local_media"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "带字幕"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "带声音"
    }
  })], 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportTab === 'video'),
      expression: "exportTab==='video'"
    }],
    staticClass: "local-options"
  }, [_c('div', {
    staticClass: "item resolution-item"
  }, [_c('span', [_vm._v("清晰度:")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "resolution-group",
    attrs: {
      "disabled": _vm.local_running
    },
    model: {
      value: (_vm.local_resolution),
      callback: function($$v) {
        _vm.local_resolution = $$v
      },
      expression: "local_resolution"
    }
  }, [_c('div', {
    staticClass: "resolution-row"
  }, [(this.vipLevel >= 100) ? _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("去水印720p"), _c('span', {
    staticClass: "tip-1"
  }, [_vm._v("("), _c('span', {
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("10点/分钟")]), _vm._v(")")])]) : _vm._e(), _vm._v(" "), (this.vipLevel >= 100) ? _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("去水印1080p"), _c('span', {
    staticClass: "tip-1"
  }, [_vm._v("("), _c('span', {
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("20点/分钟")]), _vm._v(")")])]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v("格式:")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "disabled": _vm.local_running
    },
    model: {
      value: (_vm.local_format),
      callback: function($$v) {
        _vm.local_format = $$v
      },
      expression: "local_format"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "mp4"
    }
  }, [_vm._v("MP4")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "webm"
    }
  }, [_vm._v("WebM")])], 1), _vm._v(" "), (!_vm.webcodecs_supported) ? _c('span', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.webcodecs_tip))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.local_running) ? _c('div', {
    staticClass: "local-progress"
  }, [_c('el-progress', {
    attrs: {
      "percentage": _vm.local_progress_pct
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.local_phase_text))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportTab === 'online'),
      expression: "exportTab==='online'"
    }],
    staticClass: "charging"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v("计费时长:" + _vm._s(_vm.pay_duration) + "分钟")]), _vm._v(" "), _c('span', {
    staticClass: "tip"
  }, [_vm._v("(不足一分钟，根据一分钟收费)")])]), _vm._v(" "), _c('div', {
    staticClass: "item resolution-item"
  }, [_c('span', [_vm._v("清晰度:")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "resolution-group",
    on: {
      "change": _vm.handleChangePixelWatermark
    },
    model: {
      value: (_vm.pixel_watermark_status),
      callback: function($$v) {
        _vm.pixel_watermark_status = $$v
      },
      expression: "pixel_watermark_status"
    }
  }, [_c('div', {
    staticClass: "resolution-row"
  }, [(this.vipLevel >= 100) ? _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("去水印720p"), _c('span', {
    staticClass: "tip-1"
  }, [_vm._v("("), _c('span', {
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("10点/分钟")]), _vm._v(")")])]) : _vm._e(), _vm._v(" "), (this.vipLevel >= 100) ? _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("去水印1080p"), _c('span', {
    staticClass: "tip-1"
  }, [_vm._v("("), _c('span', {
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("20点/分钟")]), _vm._v(")")])]) : _vm._e()], 1), _vm._v(" "), (this.vipLevel >= 200) ? _c('div', {
    staticClass: "resolution-row"
  }, [_c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("去水印2k"), _c('span', {
    staticClass: "tip-1"
  }, [_vm._v("("), _c('span', {
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("50点/分钟")]), _vm._v(")")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("去水印4k"), _c('span', {
    staticClass: "tip-1"
  }, [_vm._v("("), _c('span', [_vm._v("100点/分钟")]), _vm._v(")")])])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("导出点数：" + _vm._s(_vm.total_coin) + "点")])]), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportTab === 'online'),
      expression: "exportTab==='online'"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportTab === 'online'),
      expression: "exportTab==='online'"
    }],
    staticClass: "pay"
  }, [(_vm.total_coin != 0) ? _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v("点数抵用: " + _vm._s(_vm.export_money) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "tip"
  }, [_vm._v("(点数余额:" + _vm._s(_vm.export_coupon) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.fina_pay != 0) ? _c('div', {
    staticClass: "item money"
  }, [_vm._v("待支付:"), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.fina_pay) + "点")])]) : _vm._e(), _vm._v(" "), (_vm.fina_pay != 0) ? _c('el-button', {
    staticClass: "user_recharge",
    attrs: {
      "type": "warning",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleRecharge(true)
      }
    }
  }, [_vm._v("充值")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportTab === 'online'),
      expression: "exportTab==='online'"
    }],
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.handleExportToolDownload()
      }
    }
  }, [_vm._v("下载导出工具V" + _vm._s(_vm.export_tool_version) + "(windows版)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportTab !== 'online' && _vm.local_running),
      expression: "exportTab!=='online' && local_running"
    }],
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.cancelLocalExport()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportTab === 'online'),
      expression: "exportTab==='online'"
    }],
    attrs: {
      "type": "warning",
      "disabled": _vm.submit_status
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportTab === 'video'),
      expression: "exportTab==='video'"
    }],
    attrs: {
      "type": "warning",
      "disabled": _vm.local_running || !_vm.webcodecs_supported
    },
    on: {
      "click": function($event) {
        return _vm.startVideoExport()
      }
    }
  }, [_vm._v("导出视频")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.mask_export_code) ? _c('div', {
    staticClass: "mask-export-code"
  }, [_c('div', {
    staticClass: "export-2"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("提取码")]), _vm._v(" "), _c('div', {
    staticClass: "close"
  }, [_c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        return _vm.handleExportClose()
      }
    }
  })])]), _vm._v(" "), (_vm.export_code_tips_status) ? _c('div', {
    staticClass: "export_code_tips"
  }, [_vm._v("复制成功")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text code"
  }, [_vm._v("提取码: " + _vm._s(_vm.export_code))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("(20分钟有效，请复制提取码，在导出工具中使用导出)")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "id": "copy_btn",
      "type": "warning",
      "data-clipboard-action": "copy",
      "data-clipboard-target": "#clipboard"
    },
    on: {
      "click": function($event) {
        return _vm.handleCopyCode()
      }
    }
  }, [_vm._v("复制提取码")])], 1), _vm._v(" "), _c('div', {
    staticClass: "download",
    on: {
      "click": function($event) {
        return _vm.handleExportToolDownload()
      }
    }
  }, [_vm._v("\n         下载导出工具V" + _vm._s(_vm.export_tool_version) + "(windows版)\n      ")])])]) : _vm._e(), _vm._v(" "), _c('Recharge', {
    attrs: {
      "visible": _vm.pay_money_status
    },
    on: {
      "update:visible": function($event) {
        _vm.pay_money_status = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clipboard",
    staticStyle: {
      "text-indent": "-9999px"
    },
    attrs: {
      "id": "clipboard"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf14edd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Export/Export.vue
// module id = 381
// module chunks = 0